// extracted by mini-css-extract-plugin
module.exports = {"documentName":"AdacDocumentsList_documentName__vklJF"};